import { render } from "./Ohm.vue?vue&type=template&id=abcd90ca"
import script from "./Ohm.vue?vue&type=script&lang=js"
export * from "./Ohm.vue?vue&type=script&lang=js"

import "./Ohm.vue?vue&type=style&index=0&id=abcd90ca&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__